import { observable } from 'mobx';
import { Curve } from './Curve';

class Polynomial extends Curve {
  @observable coefficients = null;

  static fromJs = (props) => {
    const { coefficients } = props;
    return new Polynomial(coefficients)
  };

  constructor(coefficients) {
    super();
    this.coefficients = coefficients;
  }

  y = (x) => {
    return this.coefficients.reduce((sum, value, index) => (sum + value * (x ** index)), 0);
  };

  toJs = () => {
    return {
      type: 'Polynomial',
      coefficients: this.coefficients,
    };
  };
}

export { Polynomial };
